export const DASH_START_VEHICLE_PROTECTION = 'DASH/START_VEHICLE_PROTECTION';
export const DASH_START_ACCESSORIES_CATALOG = 'DASH/START_ACCESSORIES_CATALOG';
